import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';

import { HeaderModule } from './header/header.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { SettingsMenuComponent } from './ui-elements/settings-menu/settings-menu.component';
import { DateMenuComponent } from './ui-elements/date-menu/date-menu.component';
import { LayoutComponent } from './layout/layout.component';
import { CanAddMoreCompetitorsDirective } from './directives/can-add-more-competitors.directive';
import { CanAddMoreInternalsPagesDirective } from './directives/can-add-more-internals-pages.directive';
import { LayoutComponentAll } from './layout-all/layoutAll.component';
import { FreeMsgComponent } from './msg/Free-msg/Free-msg.component';
import { MaterialModule } from 'src/app/shared/module/material/material.module';
import { OfferBannerComponent } from './offer-banner/offer-banner.component';
import { FeedbackWidgetComponent } from './feedback/feedback-widget/feedback-widget.component';
import { CheckListComponent } from './check-list/check-list.component'
import { OopsNoDataComponent } from './oops-no-data/oops-no-data.component'
import { HelpWidgetComponent } from './help-widget/help-widget.component';
import { CruxWorkflowComponent } from '../features/home/crux-workflow/crux-workflow.component';
import { RumWorkflowComponent } from '../features/home/rum-workflow/rum-workflow.component';
import { MatSelectCountryComponent } from './components/mat-select-country/mat-select-country.component';
import { MultiCountrySelectorComponent } from './components/multi-country-selector/multi-country-selector.component';
import { CountryFlagComponent } from './components/country-flag/country-flag.component';

@NgModule({
  declarations: [
    SidebarComponent,
    FooterComponent,
    SettingsMenuComponent,
    DateMenuComponent,
    LayoutComponent,
    LayoutComponentAll,
    CanAddMoreCompetitorsDirective,
    CanAddMoreInternalsPagesDirective,
    FreeMsgComponent,
    OfferBannerComponent,
    FeedbackWidgetComponent,
    CheckListComponent,
    OopsNoDataComponent,
    HelpWidgetComponent
  ],
  imports: [
    HeaderModule,
    MatListModule,
    MatIconModule,
    RouterModule,
    MatButtonModule,
    CommonModule,
    MatMenuModule,
    MatSelectModule,
    FormsModule,
    MatSidenavModule,
    MaterialModule,
    ReactiveFormsModule,
    CruxWorkflowComponent,
    RumWorkflowComponent,
    MatSelectCountryComponent,
    MultiCountrySelectorComponent,
    CountryFlagComponent
  ],
  exports: [
    HeaderModule,
    OfferBannerComponent,
    SidebarComponent,
    FooterComponent,
    SettingsMenuComponent,
    DateMenuComponent,
    LayoutComponent,
    LayoutComponentAll,
    FreeMsgComponent,
    CheckListComponent,
    OopsNoDataComponent,
    HelpWidgetComponent,
    MatSelectCountryComponent,
    MultiCountrySelectorComponent,
    CountryFlagComponent
  ],
})
export class SharedModule { }

